import { Container } from '@mui/material'
import './footer.css'

const FooterCopy = () => {
    return (
 
        <div className="blw_fx">
            <Container maxWidth="lg">
                <p className="mb" >© {new Date().getFullYear()} EMRT MARKETS. All rights reserved</p>
            </Container>
        </div>
 
    )
}

export default FooterCopy   